if (typeof document === "undefined") return;
var extractCssCreateStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");
linkTag.setAttribute("data-vanilla-extract", "true");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;


if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
  linkTag.crossOrigin = 'anonymous';
}


	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var extractCssFindStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var extractCssLoadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (extractCssFindStylesheet(href, fullhref)) return resolve();
		extractCssCreateStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	3808: 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises, fetchPriority) {
	var cssChunks = {
107: 1,
1106: 1,
1114: 1,
1428: 1,
1956: 1,
195: 1,
2001: 1,
2111: 1,
2128: 1,
2384: 1,
2447: 1,
2448: 1,
2471: 1,
2616: 1,
2629: 1,
2720: 1,
2817: 1,
2853: 1,
2867: 1,
293: 1,
3257: 1,
325: 1,
3298: 1,
3381: 1,
3409: 1,
349: 1,
361: 1,
3674: 1,
3931: 1,
4007: 1,
405: 1,
4093: 1,
4100: 1,
4198: 1,
421: 1,
4268: 1,
4575: 1,
4585: 1,
4622: 1,
4626: 1,
4635: 1,
4667: 1,
4873: 1,
5079: 1,
5100: 1,
5192: 1,
5213: 1,
5301: 1,
5697: 1,
5713: 1,
5753: 1,
5862: 1,
5962: 1,
6235: 1,
6342: 1,
6434: 1,
6448: 1,
6481: 1,
6495: 1,
6545: 1,
6612: 1,
6833: 1,
7079: 1,
721: 1,
7348: 1,
7392: 1,
7456: 1,
7467: 1,
7478: 1,
7512: 1,
7614: 1,
7667: 1,
7691: 1,
7903: 1,
7938: 1,
7947: 1,
8172: 1,
8191: 1,
8318: 1,
8418: 1,
858: 1,
861: 1,
8647: 1,
8843: 1,
8978: 1,
9059: 1,
9066: 1,
9178: 1,
9390: 1,
9417: 1,
9478: 1,
9747: 1,
9763: 1,
9880: 1,
9991: 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = extractCssLoadStylesheet(chunkId, fetchPriority).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
// no prefetch
// no preload